import { useContext } from "react";
import { SMContext } from "../context/smContext";
import { Typography, Button } from "@mui/material";
import ModalSM from "./ModalSM";
import DivInline from "./DivInline";
import Divider10 from "./Divider10";
import General from "@ecoenghk/general";
const gs = new General();
export default function WindowButtons() {
    const [state, dispatch] = useContext(SMContext);
    const { windowButtons, windowButtonsTitle, windowButtonsOnChoose, windowButtonsOnCancel, windowBtnContentArray } = state;
    const handleClose = () => {
        dispatch({
            type: "WINDOW_BUTTONS",
            payload: { status: false, windowButtonsTitle: "" },
        });
    };

    return (
        <ModalSM open={windowButtons} onClose={handleClose} disableBottomClose>
            <Typography sx={{ marginTop: 3 }} align="center">
                {windowButtonsTitle}
            </Typography>
            <Divider10 />
            <DivInline justifyContent="space-around">
                {(windowBtnContentArray || []).map((buttonContent, index) => (
                    <Button
                        key={index}
                        variant="contained"
                        size="small"
                        onClick={async () => {
                            windowButtonsOnChoose(buttonContent, index);
                            handleClose();
                        }}
                    >
                        {buttonContent}
                    </Button>
                ))}
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => {
                        if (windowButtonsOnCancel) windowButtonsOnCancel();
                        handleClose();
                    }}
                >
                    Cancel
                </Button>
            </DivInline>
        </ModalSM>
    );
}
